export type TopCampaignMetric = 'engagement' | 'replied' | 'clicked' | 'opened' | 'sent'

export interface TopCampaignRow {
  id: number
  name: string
  metric?: TopCampaignMetric
  count?: number
  rate?: number | null
  sent?: number
  open_rate: number
}

export const TOP_CAMPAIGN_METRIC_OPTIONS: { value: TopCampaignMetric; label: string }[] = [
  { value: 'engagement', label: 'Best engagement' },
  { value: 'replied', label: 'Replied' },
  { value: 'clicked', label: 'Clicked' },
  { value: 'opened', label: 'Opened' },
  { value: 'sent', label: 'Sent' },
]

/** Badge text for a ranked campaign: a rate for engagement metrics, a volume for Sent. */
export function topCampaignBadge(row: TopCampaignRow, selected: TopCampaignMetric): string {
  const metric = row.metric ?? selected
  if (metric === 'sent') return `${(row.count ?? row.sent ?? 0).toLocaleString()} sent`
  const rate = row.rate ?? row.open_rate ?? 0
  return `${rate.toFixed(1)}%`
}

/** Secondary line, e.g. "12 of 40 emails". Empty when the API did not send counts. */
export function topCampaignDetail(row: TopCampaignRow, selected: TopCampaignMetric): string {
  const metric = row.metric ?? selected
  if (metric === 'sent' || metric === 'engagement' || row.count === undefined || row.sent === undefined) return ''
  const verb = { opened: 'opened', replied: 'replied', clicked: 'clicked' }[metric]
  return `${row.count.toLocaleString()} of ${row.sent.toLocaleString()} ${verb}`
}
